import React from "react";
import Link from "next/link";

import { Brand } from "custom-types/Brand";

import Image from "components/Image";

type Props = {
  initialBrands: Array<Brand>;
};

const BrandCoins: React.FC<Props> = ({ initialBrands }) => {
  return (
    <>
      <div className="layout">
        {initialBrands.map((brand) => {
          return (
            <Link href={`/brands/${brand.slug}`} key={brand.id} legacyBehavior>
              <a href={`/brands/${brand.slug}`} className="brand-coin">
                <Image
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  sizes={[156]}
                  ratio="square"
                  className="rounded-full elevation-low"
                />
                <div className="pt-md text-center text-green underline">
                  {brand.name}
                </div>
              </a>
            </Link>
          );
        })}
      </div>
      <style jsx>{`
        .layout {
          display: grid;
          grid-template-columns: 1fr 1fr;
          row-gap: 10px;
          column-gap: 10px;
          justify-items: center;
          padding: 20px 0px 20px 0px;
        }
        @media only screen and (min-width: 768px) {
          .layout {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            column-gap: 10px;
            row-gap: 20px;
            padding: 20px 0px 20px 0px;
            justify-items: center;
          }
        }

        @media (min-width: 1024px) {
          .layout {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
            column-gap: 10px;
            row-gap: 20px;
            padding: 20px 0px 20px 0px;
            justify-items: center;
          }
        }

        .brand-coin {
          display: block;
          width: 156px;
          max-width: 156px;
        }
      `}</style>
    </>
  );
};

export default BrandCoins;
